/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData model module.
 * @module model/MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData
 * @version 1.0
 */
class MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData {
    /**
     * Constructs a new <code>MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData</code>.
     * @alias module:model/MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData
     */
    constructor() { 
        
        MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData} obj Optional instance to populate.
     * @return {module:model/MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData} The populated <code>MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('grade')) {
                obj['grade'] = ApiClient.convertToType(data['grade'], 'Number');
            }
            if (data.hasOwnProperty('eventNo')) {
                obj['eventNo'] = ApiClient.convertToType(data['eventNo'], 'Number');
            }
            if (data.hasOwnProperty('logType')) {
                obj['logType'] = ApiClient.convertToType(data['logType'], 'Number');
            }
            if (data.hasOwnProperty('value')) {
                obj['value'] = ApiClient.convertToType(data['value'], 'Number');
            }
            if (data.hasOwnProperty('rewardPer')) {
                obj['rewardPer'] = ApiClient.convertToType(data['rewardPer'], 'Number');
            }
            if (data.hasOwnProperty('rewardMaterialId')) {
                obj['rewardMaterialId'] = ApiClient.convertToType(data['rewardMaterialId'], 'Number');
            }
            if (data.hasOwnProperty('rewardMaterialCount')) {
                obj['rewardMaterialCount'] = ApiClient.convertToType(data['rewardMaterialCount'], 'Number');
            }
            if (data.hasOwnProperty('contentNo')) {
                obj['contentNo'] = ApiClient.convertToType(data['contentNo'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} logNo
 */
MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData.prototype['logNo'] = undefined;

/**
 * @member {Number} accountNo
 */
MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData.prototype['accountNo'] = undefined;

/**
 * @member {Number} grade
 */
MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData.prototype['grade'] = undefined;

/**
 * @member {Number} eventNo
 */
MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData.prototype['eventNo'] = undefined;

/**
 * @member {Number} logType
 */
MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData.prototype['logType'] = undefined;

/**
 * @member {Number} value
 */
MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData.prototype['value'] = undefined;

/**
 * @member {Number} rewardPer
 */
MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData.prototype['rewardPer'] = undefined;

/**
 * @member {Number} rewardMaterialId
 */
MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData.prototype['rewardMaterialId'] = undefined;

/**
 * @member {Number} rewardMaterialCount
 */
MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData.prototype['rewardMaterialCount'] = undefined;

/**
 * @member {Number} contentNo
 */
MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData.prototype['contentNo'] = undefined;

/**
 * @member {Date} createdAt
 */
MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData.prototype['createdAt'] = undefined;






export default MissionControllerDtoBasicGradeRewardLogListBasicGradeRewardLogListData;

